import { Task } from '../types';

/**
 * Checks for circular dependency: does startId already depend on targetId (directly or transitively)?
 * Returns true if adding a link from startId -> targetId would cause a cycle.
 */
export function hasTransitiveDependency(
  startId: string | number,
  targetId: string | number,
  tasks: Task[],
  visited = new Set<string>()
): boolean {
  const startIdStr = String(startId);
  if (visited.has(startIdStr)) return false;
  visited.add(startIdStr);

  const startTask = tasks.find(t => String(t.id) === startIdStr);
  if (!startTask || !startTask.dependencies) return false;

  const targetIdStr = String(targetId);
  for (const dep of startTask.dependencies) {
    const depStr = String(dep);
    if (depStr === targetIdStr) return true;
    if (hasTransitiveDependency(dep, targetId, tasks, visited)) return true;
  }
  return false;
}
